import { render, staticRenderFns } from "./GrupoDeAcessoForm.vue?vue&type=template&id=56f7f6b7&scoped=true&"
import script from "./GrupoDeAcessoForm.vue?vue&type=script&lang=js&"
export * from "./GrupoDeAcessoForm.vue?vue&type=script&lang=js&"
import style0 from "./GrupoDeAcessoForm.vue?vue&type=style&index=0&id=56f7f6b7&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f7f6b7",
  null
  
)

export default component.exports